"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Podio error base class.
 * All the podio related error class will inherit from this base class.
 *
 */
class PodioError extends Error {
    /**
     *
     * @param {string} message
     */
    constructor(message, response, statusCode = 0) {
        super(message);
        this.message = message;
        this.response = response;
        this.statusCode = statusCode;
        this.name = this.constructor.name;
    }
}
exports.default = PodioError;
